var Education = "Educação";
var Enterprise = "Enterprise";
var CompanyType = {
	"Company type": "Tipo da empresa",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Governo - Federal",
	"Government - State & local": "Governo - Estadual e Municipal",
	"Non-profit": "Organizações sem fins lucrativos",
	"Self employed": "Autônomo",
	"Small-medium business": "Pequenas e médias empresas",
	"Start-up": "Startup",
	"Not applicable": "Não aplicável"
};

export { Education, Enterprise, CompanyType as default };
